/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Actions_BackInputs */

const nl_common_actions_back = /** @type {(inputs: Common_Actions_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug`)
};

/**

* @param {Common_Actions_BackInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_actions_back = /** @type {((inputs?: Common_Actions_BackInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Actions_BackInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_actions_back(inputs)
});
export { common_actions_back as "common.actions.back" }